import React from "react";
import "../../css/featured.css";
import ExploreMore from "../../ExploreMore";
import Navbar from "../../Navbar";
export const Metaindia = () => {
  return (
    <>
      <Navbar />
      <div className="featured-con">
        <div className="layout">
          <h1 className="article-title">
            Meta India Apologizes for CEO Zuckerberg's Comment on India
            Elections, Calls it an Unintentional Mistake
          </h1>
          {/* <div className="article-category">
            Canada's 10 Most Influential Women Leaders to Watch in 2024
          </div> */}
          <div className="share-container">
            <div className="share-buttons">
              <button className="share-button linkedin">LinkedIn</button>
              <button className="share-button twitter">Twitter</button>
              <button className="share-button facebook">Facebook</button>
            </div>
          </div>
          <div className="article-image-container">
            <img
              src="./images/navnews/meta-india.jpg"
              alt="Professional woman at desk"
              className="article-image"
            />
            {/* <div className="article-image-caption">
            
            </div> */}
          </div>
          {/* Article Content */}
          <div className="article-content">
            <p>
              Social media giant Meta issued an apology to the Indian government
              on Wednesday over remarks made by its Co-founder and CEO, Mark
              Zuckerberg, regarding the 2024 General Elections. The company
              described the comments as an “inadvertent error” and reaffirmed
              its commitment to India as an “important country.” Meta faced
              backlash and was set to be summoned by a Parliamentary panel for
              Zuckerberg’s “incorrect and irresponsible” statements, which were
              criticized for allegedly “spreading misinformation.” In a post on
              the social media platform X, Meta India clarified: “Mark’s
              observation that many incumbent parties were not re-elected in the
              2024 elections is accurate for several countries, but NOT India.”
              The company added, “We apologise for this inadvertent error. India
              continues to be a crucial country for @Meta, and we are committed
              to supporting its innovative future.” Zuckerberg, during a recent
              podcast, suggested that the COVID-19 pandemic had led to a decline
              in public trust in many democratic governments, contributing to
              their ouster in the 2024 elections. Union Minister for Information
              and Broadcasting and Electronics and IT, Ashwini Vaishnaw,
              strongly criticized Zuckerberg’s comments about India’s elections.
              He stated that last year’s results demonstrated the public’s trust
              in PM Modi’s leadership, culminating in a historic third-term
              victory for the NDA government. “PM Modi’s decisive third-term win
              is a reflection of good governance and the people’s trust,”
              Vaishnaw said. He called on Meta and Zuckerberg to ensure accuracy
              and responsibility in their public statements. “It’s disappointing
              to see misinformation coming from Mr. Zuckerberg himself. Meta
              must uphold facts and credibility,” the minister said in a post on
              X. Nishikant Dubey, BJP MP and Chairman of the Parliamentary
              Standing Committee on Communications and Information Technology,
              announced plans to issue a notice to Meta for “spreading
              misinformation.” He stressed the need for accountability, stating,
              “Misinformation in any democracy damages its reputation. Meta must
              apologise to the Indian Parliament and the people for this
              mistake,” Dubey said in a post on X.
            </p>
          </div>
        </div>
      </div>
      <ExploreMore />
    </>
  );
};
